import { useGoogleLogin } from "@react-oauth/google";
import { axiosHttp } from "../../../wrapper/AxiosWrapper";
import { HttpStatusCode } from "axios";
import Button from "@mui/material/Button";
import { useAuthentication } from "../../../providers/AuthenticationProvider";
import googleLogo from '../../../assets/images/logos/google.svg'
import { AvatarUtil } from "../../../util/commonUtil";

const GoogleLoginView = () => {

    const { logedInSuccess, closeLoginModal } = useAuthentication();

    const login = useGoogleLogin({
        onSuccess: credentialResponse => verifyResponse(credentialResponse),
        onError: () => console.log('Login Failed'),
    });

    const verifyResponse =(response)=>{
        axiosHttp.post("/api/dss/v1/signIn", { provider: "GOOGLE",accessToken:response.access_token, avatar: AvatarUtil.getAvatarColor()})
                    .then((response) => {
                        if (response.data.status === HttpStatusCode.Ok) {
                            logedInSuccess(response.data.content);
                        }
                    })
                    .catch((error) => { })
                    .then((res) => {
                    })
    }


    return (
        <Button variant="outlined" sx={{ px: 4,py:1.5, borderRadius: 2 }} onClick={() => {
            closeLoginModal();
            login();
        }}> 
        <img src={googleLogo}/>
       {/* <GoogleIcon /> */}
        </Button>
    );
};

export default GoogleLoginView;